import isEmpty from "./isEmpty";

/**
 * Remove all keys with null or undefined values from an object
 * 
 * @param {Object} obj - The object to clean
 * 
 * @returns {Object} The cleaned object
 */
export default function deleteEmptyKeys(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => !isEmpty(v))
  );
}
